import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useMyServices } from "../../../../../hooks/useMyServices";
import { CourseItem } from "./CourseItem";

import "./my_services.scss";

export function MyServices() {
	const { courses, createCourse } = useMyServices();
	const navigate = useNavigate();

	const onClickGoToCreateCourse = async () => {
		const newCourse = await createCourse();
		if (newCourse) {
			navigate(`/my-services/${newCourse.courseSlug}/description`);
		}
	};

	return (
		<div className="right-column-content-container">
			<div className="my-services-container">
				<div className="title-container">
					<Typography className="small-title-text bold title">
						My Services
					</Typography>
					<Button
						className="normal-button primary-button no-transform"
						onClick={onClickGoToCreateCourse}>
						Add
					</Button>
				</div>

				{courses.map((course) => (
					<CourseItem course={course} key={course.id} />
				))}
			</div>
		</div>
	);
}
